export default __webpack_public_path__ + "static/media/Bridge.c9e55373.svg";